import axios from "axios";
import { useEffect, useState } from "react";
import { BiSolidEditAlt } from "react-icons/bi";
import { API_CONFIG, API_HEADERS } from "../../../network/config/ApiConfig";
import { useLocation, useNavigate } from "react-router-dom";
function ProductPricingList() {

    const [priceList, setPriceList] = useState([]);
    const location = useLocation();
    const navigate = useNavigate();
    const product_id = location.state != null ? location.state.productId : "";
    const store_id = location.state != null ? location.state.productStoreId : "";

    useEffect(() => {
        fetchPriceList();
    }, [])

    const fetchPriceList = async () => {
        let data = await axios.get(API_CONFIG.API_HOST + `ProductPrice/list?productId=${product_id}&storeId=${store_id}`, {
            headers: API_HEADERS
        })
        setPriceList(data.data.result)
    }

    return (
        <>
            <div className="d-flex flex-row justify-content-end mt-4 p-2">
                <button className="btn btn-success"
                    onClick={() => navigate("/productPricing", { state: { productId: product_id, productStoreId: store_id } })}>Add Price</button>
            </div>
            <div className="mt-2 d-flex flex-row justify-content-center w-100">
                <div className="w-50">
                {
                    priceList && priceList.length > 0 ? priceList.map((item, i) => {
                        return (
                            <div className=" w-100" key={i}>
                                <div className="d-flex flex-row mb-3 p-2 shadow w-100">

                                    <div className="w-50">
                                        <p>{item.quantity}</p>
                                        <p>
                                            ₹{item.offer_price} <span style={{textDecoration:"line-through"}}>₹{item.price}</span>
                                        </p>
                                    </div>
                                    <div className="d-flex flex-row justify-content-end w-50" 
                                    onClick={() => navigate("/productPricing", { state: { productId: product_id, productStoreId: store_id,priceObj:item} })}
>
                                        <BiSolidEditAlt />
                                    </div>
                                </div>
                            </div>
                        )
                    }):<>No Data</>
                }
</div>
            </div>

        </>
    )

}
export default ProductPricingList